import React, { memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { ImageSizeTypes } from '../ImageInterfaces'
import Image from '..'
import PlayerImageFallback from './Fallback'

type PlayerImageProps = {
    imageUrl?: string
    alt?: string
    width: number
    size: ImageSizeTypes
} & TestID

const PlayerImage = ({ imageUrl, alt, size, width, testID }: PlayerImageProps): ReactElement => (
    <Grid noExpand center border={1} borderColor="moon-2" width={width} borderRadius={width / 2}>
        {imageUrl ? (
            <Image
                width={width - 2}
                size={size}
                aspectRatio="1:1"
                radiusType="circled"
                imageUrl={imageUrl}
                testID={testID}
                alt={alt}
            />
        ) : (
            <PlayerImageFallback width={width} testID={testID} />
        )}
    </Grid>
)

export default memo(PlayerImage)
